import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectTasksState } from "../store/tasks/selectors";
import { getTaskAttachmentsByTaskId } from "../store/tasks/thunks";

export const useTaskAttachments = (task, tenant_id) => {
  const dispatch = useDispatch();
  const { attachmentLoading: loading, columnsByTenants } =
    useSelector(selectTasksState);

  const { id: taskId, column_id: columnId } = task;

  const attachments = useMemo(() => {
    const tasks = columnsByTenants?.[tenant_id]?.[columnId]?.tasks;
    const task = tasks?.find((t) => t.id === taskId);
    return task?.attachments;
  }, [columnsByTenants, columnId, taskId, tenant_id]);

  useEffect(() => {
    if (taskId && columnId && attachments === undefined) {
      dispatch(
        getTaskAttachmentsByTaskId({
          task_id: taskId,
          column_id: columnId,
          tenant_id,
        }),
      );
    }
  }, [dispatch, taskId, attachments, columnId]);

  return {
    loading,
    attachments: attachments || [],
  };
};
